import type { Step } from '@/components/wizard/Step';

import type { CreateSparkEngineWizardState } from './createSparkEngineWizardState';
import { CreateSparkEngineStep } from './steps/CreateSparkEngineStep';

export const CreateSparkEngineFlow: Step<CreateSparkEngineWizardState> = {
  id: 'create_spark_engine',
  Component: CreateSparkEngineStep,
};
